import Button from "@mui/material/Button"
import { useTheme } from "@mui/material/styles"
const PrimaryButton = (props) => {
  const theme = useTheme()
  const { sx } = props
  return (
    <Button
      variant="contained"
      color="primary_light"
      disableElevation={true}
      {...props}
      sx={{
        mt: 2.5,
        height: "54px",
        textTransform: "none",
        whiteSpace: "nowrap",
        borderRadius: 10,
        fontWeight: 700,
        fontSize: theme.direction === "rtl" ? "18px" : "16px",
        ...sx,
      }}
    >
      {props.text}
    </Button>
  )
}

export default PrimaryButton
